<template>
  <div>
    <v-switch
      v-model="loadingSwitch"
    ></v-switch>
    <div v-if="value && loadingSwitch">
      <v-progress-linear indeterminate v-if="progressBar && value" />
      <!-- @slot Use this slot to bind the skeleton loader -->
      <slot name="skeleton-pane" v-if="skeletonLoader && value"></slot>

      <div v-if="overlay && value">
        <v-dialog scrollable :value="true" :width="400" persistent>
          <v-card>
            <v-card-title>Processing Request</v-card-title>
            <v-card-text>
              <div class="progress-dialog">

                <v-progress-circular indeterminate :size="80"></v-progress-circular>

              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>

    </div>
    <!-- @slot Use this slot to bind the value from props -->
    <!-- <slot></slot> -->

  </div>


</template>

<script>
/**
 * @displayName LoadingPane
 */
export default {
  props : {
    /**
      Hides the prompt message but the backdrop is still in visible mode
    */
    value : {type:Boolean, default:true},
    /**
      Skeleton loader
    */
    skeletonLoader : {type:Boolean, default:false},
    /**
      Simple page loading in the form of progress bar
    */
    progressBar : {type:Boolean, default:false},
    /**
      A prompt message is showing and a backdrop also added to entire screen 
    */
    overlay : {type:Boolean, default:true},
  },
  watch : {
    loadingSwitch(){
      alert("If you want to stop this loading, you have to reload this page");
    }
  },
  data: () => ({
    loadingSwitch: false,
  }),
  computed : {
  },
  methods : {
  }
};
</script>

<style scoped lang="scss">
.progress-dialog
{
  padding:40px;
  display:flex;
  justify-content:center;
  align-items:center;

}
</style>
